import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import { kindList } from "@/utils/constant";
import {
    Button,
    Table,
    Card,
    DatePicker,
    InputNumber,
    Pagination,
    Modal,
    Input,
    Select,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class GamblingRecord extends React.Component {
    state = {
        loading: false, // 是否加载中
        detailLoading: false, // 详情是否加载中
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            vendor_id: undefined,
            member_id: undefined,
            kpoker_uid: undefined,
            kind: 1,
            date: [],
        },
        data: [], // 表格数据
        kindList: [
            // 游戏列表
            ...kindList,
            { value: 1000, label: this.props.language["propConsume"] },
            { value: 1001, label: this.props.language["jackpot"] },
            { value: 1002, label: this.props.language["insurance"] },
        ],
        detailData: {}, // 详情数据
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/kpoker_union/game_log", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取详情数据
     */
    fetchDetailData = ({ mid, tunix }) => {
        axios
            .get("/v1/api/kpoker_union/game_detail", {
                params: {
                    mid,
                    tunix,
                    kind: this.state.queryParams.kind,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailData: res.data || {},
                });
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    vendor_id: undefined,
                    member_id: undefined,
                    kpoker_uid: undefined,
                    kind: 1,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    /**
     * 显示流水弹窗
     */
    handleShow = (item) => {
        this.setState(
            {
                show: true,
                title: "详情",
                detailData: {},
            },
            () => this.fetchDetailData(item)
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Input
                        allowClear
                        placeholder={this.props.language["proxyIdPlaceholder"]}
                        value={this.state.queryParams.vendor_id}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("vendor_id", e.target.value)
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["memberIdPlaceholder"]}
                        value={this.state.queryParams.member_id}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("member_id", value)
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["kpokerPlayerIdPlaceholder"]}
                        value={this.state.queryParams.kpoker_uid}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("kpoker_uid", value)
                        }
                    />
                    <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["gameTypePlaceholder"]}
                        value={this.state.queryParams.kind}
                        onChange={(value) => this.handleSetQueryParamsData("kind", value)}
                    >
                        {this.state.kindList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["startTime"]}
                            dataIndex="begin_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["endTime"]}
                            dataIndex="end_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex="mid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleName"]}
                            dataIndex="match_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.kindList.find(
                                    (kindItem) => kindItem.value === item.kind
                                )
                                    ? this.state.kindList.find(
                                        (kindItem) => kindItem.value === item.kind
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["joinNumber"]}
                            dataIndex="player_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={120}
                            render={(item) => (
                                <Button type="default" onClick={() => this.handleShow(item)}>
                                    {this.props.language["gambleDetail"]}
                                </Button>
                            )}
                        />
                    </Table>
                    <Pagination
                        className="pagination"

                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>

                {/* 查看详情弹窗 */}
                <RecordModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    loading={this.state.detailLoading}
                    pagination={false}
                    detailData={this.state.detailData}
                    onCancel={() => this.setState({ show: false })}
                />
            </div>
        );
    }
}

/**
 * 查看详情弹窗
 */
class RecordModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: '70vh',
                    overflowY: "auto",
                }}
                footer={false}
            >
                <div className="container-content">
                    {/* 牌局统计 */}
                    <Card
                        title={
                            <h2>{this.props.language["gambleStatistics"]}</h2>
                        }
                        type="inner"
                    >
                        <Table
                            dataSource={[this.props.detailData.game_stat || {}]}
                            pagination={false}
                            loading={this.props.loading}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["totalBuyIn"]}
                                dataIndex="total_buy_in"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["serviceFee"]}
                                dataIndex="fee"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["insuranceBuyamount"]}
                                dataIndex="ins_buy"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["insuranceProfit"]}
                                dataIndex="ins_profit"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["profit"]}
                                dataIndex="profit"
                            />
                        </Table>
                    </Card>

                    {/* 玩家数据 */}
                    <Card
                        className="mt20"
                        title={<h2>{this.props.language["playerData"]}</h2>}
                        type="inner"
                    >
                        <Table
                            dataSource={this.props.detailData.player_list || []}
                            pagination={false}
                            loading={this.props.loading}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["memberId"]}
                                dataIndex="member_uid"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["kpokerPlayerId"]}
                                dataIndex="kpoker_uid"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["proxyId"]}
                                dataIndex=""
                                render={(item) => (
                                    <Link to={`/proxy_detail/${item.vendor_id}`}>
                                        {item.vendor_id || ''}
                                    </Link>
                                )}
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["gameNickname"]}
                                dataIndex="name"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["buyIn"]}
                                dataIndex="buy_in"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["serviceFeeContribution"]}
                                dataIndex="fee_gain"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["serviceFeesPercentage"]}
                                dataIndex="fee_share"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["insuranceBuyamount"]}
                                dataIndex="ins_buy"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["insuranceProfit"]}
                                dataIndex="ins_profit"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["insurancePercentage"]}
                                dataIndex="ins_share"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["profit"]}
                                dataIndex="profit"
                            />
                        </Table>
                    </Card>
                </div>
            </Modal>
        );
    }
}
